import React, { useEffect, useState } from "react";
import { auth, db, storage } from "../utils/firebase";
import { doc, getDoc, updateDoc, collection, getDocs, deleteDoc, query, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { getDownloadURL, ref, uploadBytes, listAll, deleteObject } from "firebase/storage";
import Navbar from './navbar/Navbar';
import Footer from './footer/Footer';
import "../styles/profile.css";
import { Link } from 'react-router-dom';
import DeleteModal from "./regmodals/DeleteModal"; 


function UserProfile() {
  const [userInfo, setUserInfo] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    birthday: { month: "", day: "", year: "" },
    email: "",
  });
  const [favorites, setFavorites] = useState([]);
  const [posts, setPosts] = useState([]);
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [imageURL, setImageURL] = useState("");
  const [editingPostId, setEditingPostId] = useState(null);
  const [editingPostText, setEditingPostText] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [postIdToDelete, setPostIdToDelete] = useState(null); 

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setIsLoggedIn(true);
        setLoading(true); // Optional: Show a loading state if needed.
        await fetchUserData(user.uid);
        await fetchFavorites(user.uid);
        await fetchPosts(user.uid);
        await fetchProfileImage(user.uid); // Fetch profile image specific to the current user.
        setLoading(false);
      } else {
        setIsLoggedIn(false);
        setProfileImage(null); // Clear the profile image for logged-out or new users.
        setLoading(false);
      }
    });
  
    return () => unsubscribe();
  }, []);
  
  const fetchProfileImage = async (uid) => {
    try {
      const userDoc = await getDoc(doc(db, "Users", uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        if (data.profile_image) {
          setProfileImage(data.profile_image);
          localStorage.setItem("profile_image", data.profile_image);
        } else {
          console.log("No profile image found for user.");
          setProfileImage(null); // Ensure no image is shown if none exists.
          localStorage.removeItem("profile_image");
        }
      } else {
        console.log("User document does not exist.");
        setProfileImage(null);
      }
    } catch (error) {
      console.error("Error fetching profile image:", error);
      setProfileImage(null);
    }
  };



useEffect(() => {
  const fetchAndSetProfileImage = async () => {
    const storedProfileImage = localStorage.getItem("profile_image");
    if (storedProfileImage) {
      setProfileImage(storedProfileImage); 
    } else {
      const user = auth.currentUser;
      if (user) {
        await fetchProfileImage(user.uid); 
      } else {
        console.log("No user is currently logged in.");
      }
    }
  };

  fetchAndSetProfileImage();
}, []);


  const fetchUserData = async (uid) => {
    try {
      const userDoc = await getDoc(doc(db, "Users", uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        setUserInfo({
          ...data,
          birthday: parseBirthday(data.birthday),
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFavorites = async (uid) => {
    try {
    
      const userDoc = await getDoc(doc(db, "Users", uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
    
       
        if (data.favorites) {
          const allFavorites = [];
    
    
          for (const [category, items] of Object.entries(data.favorites)) {
            for (const item of items) {
              try {
    
                const formattedItemName = item.replace(/\s+/g, '').toLowerCase();
    
                const placesImageRef = ref(storage, `places/${formattedItemName}.jpg`);
                const placesImageURL = await getDownloadURL(placesImageRef).catch(() => null);
    
                const thingsImageRef = ref(storage, `things/${formattedItemName}.jpg`);
                const thingsImageURL = await getDownloadURL(thingsImageRef).catch(() => null);

    
                const imageURL = placesImageURL || thingsImageURL || null;
    
                allFavorites.push({
                  name: item,
                  category,
                  imageURL,
                });
              } catch (error) {
                console.error(`Error fetching image for ${item}:`, error);
                allFavorites.push({
                  name: item,
                  category,
                  imageURL: null, 
                });
              }
            }
          }
    
          setFavorites(allFavorites);
        }
      }
    } catch (error) {
      console.error("Error fetching favorites:", error);
    }
  };

  const parseBirthday = (birthdayString) => {
    const [month, day, year] = birthdayString.split(" ");
    return { month, day, year };
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("birthday.")) {
      setUserInfo((prev) => ({
        ...prev,
        birthday: { ...prev.birthday, [name.split(".")[1]]: value },
      }));
    } else {
      setUserInfo((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async () => {
    const user = auth.currentUser;
    if (user) {
      try {
        await updateDoc(doc(db, "Users", user.uid), {
          ...userInfo,
          birthday: `${userInfo.birthday.month} ${userInfo.birthday.day}, ${userInfo.birthday.year}`,
        });
        toast.success("Profile updated successfully!");
        setEditing(false);
      } catch (error) {
        toast.error("Failed to update profile.");
      }
    }
  };

  const handleEditPost = (postId, postText) => {
    setEditingPostId(postId);
    setEditingPostText(postText);
  };

  const handleSavePostChanges = async () => {
    try {
      const postRef = doc(db, "posts", editingPostId);
      await updateDoc(postRef, { text: editingPostText });
      toast.success("Post updated successfully!");
      setEditingPostId(null); 
      setEditingPostText(""); 
      fetchPosts(auth.currentUser.uid);
    } catch (error) {
      toast.error("Failed to save post changes.");
    }
  };

  const handleCancelEdit = () => {
    setEditingPostId(null);
    setEditingPostText(""); 
  };

  const handleDeleteClick = (postId) => {
    setPostIdToDelete(postId);  // Store the post ID
    setShowModal(true);  // Open the modal for confirmation
  };
  
  const handleCloseModal = () => {
    setShowModal(false);  // Close the modal
  };
  
  const handleDeletePost = async (postId) => {
    try {
      const postRef = doc(db, "posts", postId);
      await deleteDoc(postRef);
      toast.success("Post deleted successfully!");
      fetchPosts(auth.currentUser.uid);  // Refresh the posts list
      console.log("Post deleted:", postId);
      setShowModal(false);  // Close the modal after deletion
    } catch (error) {
      toast.error("Failed to delete post.");
      console.error("Error deleting post:", error);
    }
  };
  

  const handleImageChange = async (e) => {
    const files = e.target.files; 
    if (files.length > 0 && editingPostId) {
      const postRef = doc(db, "posts", editingPostId);
      const imageUrls = [];
  
      try {
        for (const file of files) {
          const storageRef = ref(storage, `posts/${auth.currentUser.uid}/${editingPostId}/${file.name}`);
          await uploadBytes(storageRef, file);
          const downloadURL = await getDownloadURL(storageRef);
          imageUrls.push(downloadURL);
        }
  
      
        await updateDoc(postRef, {
          imageUrls,
        });
  
        toast.success("Images updated successfully!");
        fetchPosts(auth.currentUser.uid); 
      } catch (error) {
        console.error("Error uploading images:", error);
        toast.error("Failed to update images.");
      }
    }
  };
  

  const fetchPosts = async (uid) => {
    try {
      const postsQuery = query(collection(db, "posts"), where("userId", "==", uid));
      const postSnapshot = await getDocs(postsQuery);
  
      if (!postSnapshot.empty) {
        const postsData = [];
  
        for (const postDoc of postSnapshot.docs) {
          const postData = postDoc.data();
          const postId = postDoc.id;
  
          let imageUrls = postData.imageUrls || [];
  
          // Only fetch images from Firebase Storage if there are no URLs in Firestore
          if (imageUrls.length === 0) {
            try {
              const storageRef = ref(storage, `posts/${uid}/${postId}`);
              const imageRefs = await listAll(storageRef);
              imageUrls = await Promise.all(
                imageRefs.items.map((item) => getDownloadURL(item))
              );
            } catch (error) {
              console.error(`Error fetching images for post ${postId}:`, error);
            }
          }
  
          postsData.push({
            id: postId,
            ...postData,
            imageUrls,
          });
        }
  
        setPosts(postsData);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleRemoveFavorite = async (favoriteName, category) => {
    const user = auth.currentUser;
    if (user) {
      try {
   
        const userDoc = doc(db, "Users", user.uid);
        const userSnap = await getDoc(userDoc);
        
        if (userSnap.exists()) {
          const data = userSnap.data();
          
    
          const updatedFavorites = { ...data.favorites };
          
          if (updatedFavorites[category]) {
            updatedFavorites[category] = updatedFavorites[category].filter(
              (item) => item !== favoriteName
            );
          }
          
       
          await updateDoc(userDoc, { favorites: updatedFavorites });
          
          toast.success(`${favoriteName} removed from favorites!`);
        
          fetchFavorites(user.uid);
        }
      } catch (error) {
        toast.error("Failed to remove favorite.");
      }
    }
  };

  const handleRatingChange = async (postId, newRating) => {
    try {
      const postRef = doc(db, "posts", postId);
      await updateDoc(postRef, { rating: newRating });
  
      toast.success("Rating updated successfully!");
      fetchPosts(auth.currentUser.uid);
    } catch (error) {
      console.error("Error updating rating:", error);
      toast.error("Failed to update rating.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleRemoveImage = async (postId, imageUrl) => {
    try {
      // Reference to the Firestore document for the specific post
      const postRef = doc(db, "posts", postId);
  
      // Fetch the current post data
      const postSnapshot = await getDoc(postRef);
      const postData = postSnapshot.data();
  
      // Filter out the imageUrl from the imageUrls array
      const updatedImageUrls = postData.imageUrls.filter((url) => url !== imageUrl);
  
      // Delete the image from Firebase Storage
      const storageRef = ref(storage, imageUrl);
      await deleteObject(storageRef);
  
      // Update the Firestore document to remove the imageUrl
      await updateDoc(postRef, { imageUrls: updatedImageUrls });
  
      // Update local state directly for immediate UI reflection
      setPosts((prevPosts) =>
        prevPosts.map((post) =>
          post.id === postId
            ? { ...post, imageUrls: updatedImageUrls }  // Update the imageUrls locally
            : post
        )
      );
  
      // Refetch the posts from Firestore to ensure the data is synced
      fetchPosts(auth.currentUser.uid);
  
      // Show a success toast
      toast.success("Image removed successfully!");
    } catch (error) {
      console.error("Error removing image:", error);
      toast.error("Failed to remove image.");
    }
  };
  
  

  const handleImageUpload = async (e) => {
    const file = e.target.files[0]; 
    if (file) {
      const storageRef = ref(storage, `profile_images/${auth.currentUser.uid}/${file.name}`);
      try {
        await uploadBytes(storageRef, file); 
        const downloadURL = await getDownloadURL(storageRef); 
        setProfileImage(downloadURL);
  
       
        await updateDoc(doc(db, "Users", auth.currentUser.uid), {
 
          profile_image: downloadURL, 
        });
  
        toast.success("Profile image updated!");
      } catch (error) {
        toast.error("Failed to upload profile image.");
        console.error("Error uploading profile image:", error);
      }
    }
  };
  
  return (
    <div className="home-page">
      <Navbar />
                <div className="profile-page">
                  <h2>User Profile</h2>
                  <div className="profile-info">
            <h3>Personal Information</h3>
            <div className="field-group">
            <label>Profile Image:</label>
            <div className="profile-image-container">
            
              {profileImage ? (
                
                <img
                  src={profileImage}
                  alt="Profile"
                  style={{ width: "100px", height: "100px", borderRadius: "50%" }}
                />
              ) : (
                
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    fontSize: "2rem",
                  }}
                >
                  <i className="bi bi-person"></i>
                </div>
              )}
                <input
                  type="file"
                  onChange={handleImageUpload}
                  accept="image/*"
                  disabled={!editing}
                />
              </div>
            
            <label>First Name:</label>
            <input
              type="text"
              name="firstName"
              value={userInfo.firstName || ""}
              onChange={handleInputChange}
              disabled={!editing}
            />
          </div>
          <div className="field-group">
            <label>Last Name:</label>
            <input
              type="text"
              name="lastName"
              value={userInfo.lastName || ""}
              onChange={handleInputChange}
              disabled={!editing}
            />
          </div>
          <div className="field-group">
            <label>Gender:</label>
            <select
              name="gender"
              value={userInfo.gender || ""}
              onChange={handleInputChange}
              disabled={!editing}
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Prefer not to say">Prefer not to say</option>
            </select>
          </div>
          <div className="field-group">
            <label>Birthday:</label>
            <div className="birthday-fields">
              <select
                name="birthday.month"
                value={userInfo.birthday.month || ""}
                onChange={handleInputChange}
                disabled={!editing}
              >
                <option value="">Month</option>
                {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>
              <select
                name="birthday.day"
                value={userInfo.birthday.day || ""}
                onChange={handleInputChange}
                disabled={!editing}
              >
                <option value="">Day</option>
                {[...Array(31).keys()].map((day) => (
                  <option key={day + 1} value={day + 1}>
                    {day + 1}
                  </option>
                ))}
              </select>
              <select
                name="birthday.year"
                value={userInfo.birthday.year || ""}
                onChange={handleInputChange}
                disabled={!editing}
              >
                <option value="">Year</option>
                {[...Array(120).keys()].map((year) => (
                  <option key={year + 1900} value={year + 1900}>
                    {year + 1900}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="field-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={userInfo.email || ""}
              onChange={handleInputChange}
              disabled
            />
          </div>
          <div className="profile-buttons">
            {editing ? (
              <>
                <button className="save-btn" onClick={handleSave}>
                <i className="bi bi-check-circle me-1"></i> Save Changes
              </button>
              <button
                className="cancel-btn"
                onClick={() => setEditing(false)}
              >
                <i className="bi bi-x-circle me-1"></i> Cancel
              </button>
              </>
            ) : (
              <button className="edit-btn" onClick={() => setEditing(true)}>
                <i className="bi bi-pencil-square me-1"></i> Edit
              </button>
            )}
          </div>
        </div>

        <div className="favorites-section">
            <h3>Favorites</h3>
            {favorites.length > 0 ? (
              <div className="favorites-cards">
                {favorites.map((fav, index) => {
     
                  let route = '';

                  switch(fav.name.toLowerCase()) {
                    case 'molino dam':
                      route = '/molinodam';
                      break;
                    case 'strike gymnasium':
                      route = '/strikegym';
                      break;
                    case 'senyong\'s museum':
                      route = '/senyongsmuseum';
                      break;
                    case 'bacoor eco-park':
                      route = '/bacoorpark';
                      break;
                    case 'prinza dam':
                      route = '/prinzadam';
                      break;
                    case 'tulay ng zapote':
                      route = '/tulayzapote';
                      break;
                    case 'fr. mariano gomes monument':
                      route = '/marianogomes';
                      break;
                      case 'kainan sa balsa':
                        route = '/kainanbalsa';
                      break;
                      case 'seafood terminal':
                        route = '/kainanbalsa';
                      break;
                      case 'digman halo-halo':
                        route = '/digmanhalo';
                      break;
                      case 'monument of love':
                        route = '/monumentlove';
                      break;
                      case 'general edilberto evangelista monument':
                        route = '/edilbertomonument';
                      break;
                      case 'ginintuang kasaysayan ng lungsod ng bacoor':
                        route = '/ginintuan';
                      break;
                      case 'bahay ni tisa':
                        route = '/bahaytisa';
                      break;
              
                      case 'justice buenaventura a. ocampo ancestral house':
                        route = '/justicehouse';
                      break;
                      case 'st. michael the archangel church':
                        route = '/michaelchurch';
                      break;
                      case 'bacoor unida evangelical church':
                        route = '/unidachurch';
                      break;
                      case 'sm city bacoor':
                      route = '/smbacoor';
                    break;
                    case 'nomo':
                      route = '/nomo';
                    break;
                    case 'sm city molino':
                      route = '/smmolino';
                    break;
                    case 'sto. niño de molino parish church':
                      route = '/stonino';
                    break;
                    case 'somo market':
                      route = '/somo';
                    break;
                    case 'st. ezekiel moreno park':
                      route = '/stezekiel';
                    break;
                    case 'rfc molino mall':
                      route = '/rfcmall';
                    break;
                    case 'main square bacoor':
                      route = '/mainsquare';
                    break;
                    case 'r. antonio\'s':
                      route = '/rantonio';
                    break;
                    case 'funnside ningnangan bacoor':
                      route = '/funnside';
                    break;
                    case 'brick wood ph':
                      route = '/brickwood';
                    break;
                    case 'cocina sa garaje gervasio':
                      route = '/cocina';
                    break;

                    case 'cavite state university - bacoor campus':
                      route = '/cvsu';
                    break;

                    default:
                      route = '/';
                  }

                  return (
                    <div key={index} className="favorite-card">
                      {/* Link to the corresponding route */}
                      <Link to={route}>
                        <img
                          src={fav.imageURL || "placeholder-image-url"} 
                          alt={fav.name || "Favorite Place"}
                          className="favorite-image"
                        />
                      </Link>
                      <div className="favorite-info">
                        <h4>{fav.name}</h4>
                        <p>Category: {fav.category}</p>
                        <button
                          className="remove-favorite-button"
                          onClick={() => handleRemoveFavorite(fav.name, fav.category)}
                        >
                          Remove from Favorites
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p>No favorites added yet.</p>
            )}
          </div>

  <div className="posts-section">
    <h3>Your Posts</h3>
    {posts.length > 0 ? (
      <div className="profile-container">
        <div className="posts-grid">
          {posts.map((post) => (
            <div className="post-card" key={post.id}>
              <div className="post-images">
                {post.imageUrls.map((url, index) => (
                  <img src={url} alt={`Post image ${index + 1}`} key={index} />
                ))}
              </div>
              <p className="post-text">{post.text}</p>
              <p className="post-location">Location: {post.location}</p>
              <div className="rating-container">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={`star ${post.rating >= star ? "selected" : ""}`}
                  >
                    &#9733;
                  </span>
                ))}
              </div>
              <p className="post-rating">Rating: {post.rating} ★</p>

              {editingPostId === post.id ? (
                <div className="post-editing">
                  {/* Text Area for Editing Post */}
                  <textarea
                    value={editingPostText}
                    onChange={(e) => setEditingPostText(e.target.value)}
                  />
                  {/* Image Preview with Remove Button */}
                  <div className="image-preview-container">
                    {post.imageUrls.map((url, index) => (
                      <div key={index} className="image-preview">
                        <img src={url} alt={`Post image ${index + 1}`} />
                        <button
                          className="remove-image-button"
                          onClick={() => handleRemoveImage(post.id, url)}
                        >
                          &#10006; {/* "X" symbol */}
                        </button>
                      </div>
                    ))}
                  </div>
                  {/* Change Image Section */}
                  <div className="change-image">
                    <h4>Change Image</h4>
                    <input
                      type="file"
                      multiple
                      onChange={handleImageChange}
                      accept="image/*"
                    />
                  </div>
                  {/* Change Rating Section */}
                  <div className="change-rating">
                    <h4>Change Rating</h4>
                    <div className="rating-edit">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={`star ${star <= post.rating ? "selected" : ""}`}
                          onClick={() => handleRatingChange(post.id, star)}
                        >
                          &#9733;
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Save and Cancel Buttons */}
                  <button
                    className="save-btn"
                    onClick={handleSavePostChanges}
                    title="Save Changes"
                  >
                    <i className="bi bi-check-circle"></i>
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={handleCancelEdit}
                    title="Cancel"
                  >
                    <i className="bi bi-x-circle"></i>
                  </button>
                </div>
              ) : (
                <div className="post-actions">
                  <button
                    className="edit-btn"
                    onClick={() => handleEditPost(post.id, post.text, post.imageUrls)}
                    title="Edit Post"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => handleDeleteClick(post.id)}  // Pass post ID here
                    title="Delete Post"
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                  <DeleteModal
                    show={showModal}
                    onClose={handleCloseModal}
                    onDelete={() => handleDeletePost(postIdToDelete)}  // Use stored postIdToDelete
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    ) : (
      <p>No posts found.</p>
    )}
  </div>
      </div>
      <Footer />
    </div>

  );
}

export default UserProfile;
